export default "<p>reset-password works!</p>\r\n"